import { parse } from 'qs';
import forceCast from './forceCast';

const parseQuery = <T>(url: string): T =>
    forceCast<T>(
        parse(url.slice(url.lastIndexOf('?') + 1), {
            ignoreQueryPrefix: true,
        }),
    );

export default parseQuery;
